import BulkConsentManager, {
  getBulkConsentManager,
} from "helpers/consent/BulkConsentManager";
import { NULL } from "constants/primitives";
import WidgetConfig from "helpers/init/WidgetConfig";
import { bulkLogger } from "helpers/logger";
import report from "helpers/report";
import createPromise from "helpers/createPromise";
import { genericObject } from "types/generic";

const deleteBulkConsent = (bulkConfig: WidgetConfig["bulkConsent"]) => {
  const { id, iframeUrl } = bulkConfig;
  return createPromise<genericObject | null>((resolve) => {
    const msg = {
      group_id: id,
      action: "remove",
    };
    const manager: BulkConsentManager = getBulkConsentManager(iframeUrl);

    manager.sendMessage<genericObject | null>(msg).then(
      (res) => resolve(res),
      (e) => {
        bulkLogger("Failed to delete bulk consent");
        report(e);
        resolve(NULL);
      }
    );
  });
};

export default deleteBulkConsent;
